import * as FullStory from "@fullstory/browser";
import { push } from "connected-react-router";

import * as types from "./types";
import handleResponse from "../../shared/handleResponse";
import { logEvent } from "../../shared/eventLogger";

const PAYMENT_INTENT_SPELL = "payment_intent";

export const setToken = (token: string): object => ({
  type: types.SET_TOKEN,
  payload: token,
});

export const setStatus = (status: string): object => ({
  type: types.SET_STATUS,
  payload: status,
});

export const setInvocations = (invocations: object): object => ({
  type: types.SET_INVOCATIONS,
  payload: invocations,
});

export const delInvocations = (invocations: string[]): object => ({
  type: types.DELETE_INVOCATIONS,
  payload: invocations,
});

export const setPaymentDetails = (paymentDetails: PaymentDetailsProps): object => ({
  type: types.SET_PAYMENT_DETAILS,
  payload: paymentDetails,
});

export const setPublisher = (publisher: object): object => ({
  type: types.SET_PUBLISHER,
  payload: publisher,
});

export const isProcessingPayment = (processing: boolean): object => ({
  type: types.IS_PROCESSING_PAYMENT,
  payload: processing,
});

export const changePath = (path: string) => async (dispatch: Function) => {
  localStorage.setItem("path", path);
  logEvent("screen_view", { app_name: "merlin", screen_name: path });
  dispatch(push(path));
};

type InvocationProps = { status: string; invocations: object };
const invocationSuccess = (dispatch: Function, path?: string) => ({
  status,
  invocations,
}: InvocationProps) => {
  FullStory.setUserVars(invocations);
  dispatch(setStatus(status));
  dispatch(setInvocations(invocations));
  if (path) dispatch(changePath(path));
};

const deleteInvocationsSuccess = (
  dispatch: Function,
  toRemoveInvocations: string[],
) => () => {
  dispatch(delInvocations(toRemoveInvocations));
};

export const invocate = (spell: string, value: any, path?: string) => async (
  dispatch: Function,
) => {
  const formData = new FormData();
  formData.append("spell_name", spell);
  formData.append("value", value);
  const onSuccess = invocationSuccess(dispatch, path);

  await handleResponse("post", "/invocations", onSuccess, dispatch, formData);
};

export const deleteInvocations = (spells: string[]) => async (dispatch: Function) => {
  const params = { spells: spells };
  const onSuccess = deleteInvocationsSuccess(dispatch, spells);

  await handleResponse("delete", "/invocations", onSuccess, dispatch, params);
};

type PaymentIntentProps = { payment_secret: string };
const paymentIntentSuccess = (dispatch: Function) => ({
  payment_secret,
}: PaymentIntentProps) => {
  // Register created intent as a invocation
  dispatch(invocate(PAYMENT_INTENT_SPELL, payment_secret));
};

export type PaymentDetailsProps = {
  last_numbers: string;
  card_brand: string;
  created_at: string;
};
type PaymentDetailsReponse = { payment_details: PaymentDetailsProps };
const paymentDetailsSuccess = (dispatch: Function) => ({
  payment_details,
}: PaymentDetailsReponse) => {
  dispatch(setPaymentDetails(payment_details));
};

export const updatePaymentIntent = (amount: number) => async (dispatch: Function) => {
  const formData = new FormData();
  formData.append("amount", amount.toString());

  await handleResponse("put", "/payments/intent", () => {}, dispatch, formData);
};

export const submitPaymentIntent = (amount: number) => async (dispatch: Function) => {
  const formData = new FormData();
  formData.append("amount", amount.toString());
  const onSuccess = paymentIntentSuccess(dispatch);

  logEvent("begin_checkout", { currency: "USD", value: amount });
  await handleResponse("post", "/payments/intent", onSuccess, dispatch, formData);
};

export const fetchPaymentDetails = () => async (dispatch: Function) => {
  const onSuccess = paymentDetailsSuccess(dispatch);
  await handleResponse("get", "/payments/details", onSuccess, dispatch, {});
};

export const setIsProcessingPayment = (processing: boolean) => async (
  dispatch: Function,
) => {
  dispatch(isProcessingPayment(processing));
};
